<h3 mat-dialog-title class="m-0 mb-1">
  {{modalOptions.title}}
</h3>
<div mat-dialog-content>
  {{modalOptions.message}}
  <br>
  <span class="bold-item redirect pr-2" *ngIf="viewAppt">
    <a class="text-manax cursor-pointer" (click)="viewAppt = !viewAppt">
      Ocultar visitas <!--<i class="material-icons">arrow_upward</i>--> 
    </a>
  </span>

  <span class="bold-item redirect pr-2" *ngIf="!viewAppt">
    <a class="text-manax cursor-pointer" (click)="viewAppt = !viewAppt">
      Ver visitas <!--<i class="material-icons">arrow_downward</i>-->
    </a>
  </span>

  <div style="height:250px; overflow: auto;" *ngIf="viewAppt">
    <table class="table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Personal asignado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td [ngStyle]="item.canDeleted ? null : {'color': 'red'}">{{item.dayOfWeek}} {{item.startDate | date:'dd/MM/yyyy'}}</td>
          <td [ngStyle]="!item.canDeleted ? {'color': 'red'} : null">
            <ul>
              <li *ngFor="let itemW of item.workers"><b>{{itemW.firstname}} {{itemW.lastname}}</b></li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="p-0">
    <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-lavuro" (click)="dialog.close(true)">
      {{modalOptions.yesButtonLabel}}
    </button>
    <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link" (click)="dialog.close(false)">
      {{modalOptions.noButtonLabel}}
    </button>
  </div>
</div>